module.exports = __webpack_public_path__ + "static/media/Action_logs.e8e00158.svg";